import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const buildReport = async (reportData) => {
  const data = await request.post(
    '/Report/dashboard',
    reportData,
    'При формировании отчета произошла ошибка',
    undefined,
    undefined,
    {},
  );

  return data;
};

const useBuildReportMutation = () => {
  return useMutation((reportData) => buildReport(reportData));
};

export default useBuildReportMutation;
